import React from 'react';
import { BrowserRouter, useLocation } from 'react-router-dom';
import AppRoutes from './routes/AppRoutes';
import Navbar from './components/layout/Navbar';
import Footer from './components/layout/Footer';

const Layout = () => {
  const location = useLocation();
  
  // Define paths where the Navbar and Footer should not be visible
  const noLayoutPaths = ['/auth', '/login'];
  
  // Check if the current path is one of the no-layout paths
  const showLayout = !noLayoutPaths.includes(location.pathname);

  return (
    <>
      {showLayout && <Navbar />}
      <AppRoutes />
      {showLayout && <Footer />}
    </>
  );
};

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Layout />
      </BrowserRouter>
    </div>
  );
}

export default App;
